(ns frontend.ui.component.lp-portal.voima-components.chart-card.chart-card
  (:require
   [common.localization :as loc]
   [common.util :as cu]
   [frontend.ui.component.lp-portal.voima-components.card.view :as card]
   [frontend.ui.component.chart.view :as chart]
   [frontend.ui.component.lp-portal.voima-components.text-content.view :as text-content]
   [frontend.ui.component.text-input.view :as text-input]
   [reagent.core :as r]
   [ui.components.button.view :as button]))

(defn- editable-title
  "Chart card title the report editor can rename in place. The draft is only
   committed on save, so an abandoned edit leaves the stored title untouched.
   Saving blank clears the override and the card falls back to its default."
  [_data _display-title _default-title _save-text]
  (let [local-state* (r/atom {:editing? false
                              :draft    nil})]
    (fn [{:keys [custom-title custom-title-path]} display-title default-title save-text]
      (let [{:keys [editing? draft]} @local-state*
            cancel-edit #(swap! local-state* assoc :editing? false :draft nil)
            ;; Read the draft from the atom, not the closed-over render value,
            ;; so a keystroke in the same tick as the click can't commit stale.
            save-edit (fn []
                        (save-text custom-title-path
                                   (cu/str-trim (str (:draft @local-state*))))
                        (cancel-edit))]
        [:div
         {:class "flex items-center gap-2"}
         (if editing?
           [:<>
            ;; The card title container uppercases and letter-spaces its text.
            [:div
             {:style {:text-transform "none"
                      :letter-spacing "normal"}}
             [text-input/text-input
              {:type        "text"
               :value       (str draft)
               :placeholder default-title
               :on-change   #(swap! local-state* assoc :draft (str %))
               :on-key-down (fn [e]
                              (case (.-key e)
                                "Enter"  (save-edit)
                                "Escape" (cancel-edit)
                                nil))}]]
            [button/square-secondary-hollow
             {:on-click save-edit
              :tooltip  (loc/tr :save)}
             [:i {:class "fal fa-check"}]]
            [button/square-secondary-hollow
             {:on-click cancel-edit
              :tooltip  (loc/tr :cancel)}
             [:i {:class "fal fa-times"}]]]
           [:<>
            [:span display-title]
            [button/square-secondary-hollow
             {:on-click #(swap! local-state* assoc
                                :editing? true
                                :draft (if (cu/blank-value? custom-title)
                                         default-title
                                         custom-title))
              :tooltip  (loc/tr :lp-report-edit-chart-title)}
             [:i {:class "fal fa-pencil"}]]])]))))

(defn view
  [title data props]
  (let [removed-since-empty? (->> data
                                  :figures
                                  :series
                                  (filter (fn [{:keys [data]}]
                                            (seq (remove nil? data))))
                                  (count)
                                  (= 0))
        {:keys [custom-title custom-title-path]} data
        {:keys [edit-mode? save-text]} props
        effective-title (if (cu/blank-value? custom-title)
                          title
                          custom-title)
        display-title (if (or removed-since-empty? (:removed-since-empty? props))
                        (str effective-title " --> Missing data! (Note: Will be hidden, if no data is provided)")
                        effective-title)
        ;; Only cards threaded through report-ctl/with-custom-title have a path.
        editable-title? (and edit-mode?
                             (fn? save-text)
                             (seq custom-title-path))]
    (if (and (not edit-mode?)
             removed-since-empty?)
      nil
      [card/card
       {:title           (if editable-title?
                           [editable-title data display-title title save-text]
                           display-title)
        :border?         (:border? props)
        :centered-title? (:centered-title? props)
        :preserve-title-case? (:preserve-title-case? props)
        :removed-since-empty? (or removed-since-empty? (:removed-since-empty? props))}
       [:<>
        [chart/chart data props] ;;TODO check that this doesnt break non editable tables
        (when-not (or removed-since-empty? (:removed-since-empty? props) (:hide-footnote? props))
          (text-content/optional-footnote data props))]])))

(defn row-view
  [title data props]
  [:div
   {}
   [view title data props]])
